import React from "react";
import { CheckCircle2, XCircle } from "lucide-react";

export function Stat({ label, value, icon, accent = false }) {
  return (
    <div className="bg-white rounded-2xl border border-[#e3eaf2] p-4">
      <p className="text-[11px] tracking-[0.18em] uppercase flex items-center gap-1.5" style={{ color: "var(--np-muted)" }}>{icon}{label}</p>
      <p className="mt-1 text-2xl" style={{ color: accent ? "var(--np-secondary)" : "var(--np-primary)", fontFamily: "Merriweather, serif" }}>{value}</p>
    </div>
  );
}

export function Dot({ on, label }) {
  return (
    <span className={`inline-flex w-6 h-6 items-center justify-center rounded-full text-[10px] font-bold ${on ? "text-white" : "text-slate-400 bg-slate-100"}`} style={on ? { background: "var(--np-secondary)" } : {}}>
      {label}
    </span>
  );
}

export function RevCard({ label, cents, note, accent = false }) {
  const eur = ((cents || 0) / 100).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return (
    <div className="bg-white rounded-2xl border p-5" style={{ borderColor: accent ? "var(--np-secondary)" : "#e3eaf2" }} data-testid={`rev-card-${label.toLowerCase().replace(/\s+/g, "-")}`}>
      <p className="text-[11px] tracking-[0.18em] uppercase" style={{ color: "var(--np-muted)" }}>{label}</p>
      <p className="mt-2 text-3xl" style={{ color: accent ? "var(--np-secondary)" : "var(--np-primary)", fontFamily: "Merriweather, serif" }}>€ {eur}</p>
      {note && <p className="mt-1 text-xs" style={{ color: "var(--np-muted)" }}>{note}</p>}
    </div>
  );
}

export function StatusBadge({ ok, label }) {
  return (
    <span className={`inline-flex items-center gap-1 text-xs font-semibold px-2 py-1 rounded-full border ${
      ok ? "text-emerald-700 bg-emerald-50 border-emerald-200" : "text-slate-600 bg-slate-50 border-slate-200"
    }`}>
      {ok ? <CheckCircle2 size={12} /> : <XCircle size={12} />}{label}
    </span>
  );
}
